import { axiosInstance as request } from '@/api/rest.service'

export const getRecentActions = params => {
  return request.get('/recent-actions?paginated=true', { params })
}
